// ** React Imports
import { useState } from "react";

// ** Redux & Store & Actions
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { addLink, getLinks } from "store/modules/userpanel-links";

// ** Third Party Components
import Tooltip from "components/layout/Tooltip";
import { toast } from "helpers/toastWrapper";

// ** Custom Components

import Block from "components/layout/Block";
import { UserpanelRow } from "containers/Userpanel/components/UserpanelRow";
import { UserpanelSection } from "containers/Userpanel/components/UserpanelSection";
import { ButtonPrimary } from "components/layout/Button/ButtonPrimary";
import SelectorSelectSingle from "components/layout/DropdownSelectors/SelectorSelectSingle";
import InputSelector from "components/layout/InputSelector";

// #####################################################

const AddingForm = () => {
	const { t } = useTranslation(["userpanel", "suspensions"]);
	const dispatch = useDispatch();

	const suspension = useSelector((state) => state.user?.suspension);

	const [type, setType] = useState(null);
	const [link, setLink] = useState("");
	const [isAdding, setIsAdding] = useState(false);

	const isBan = suspension?.duration > 0;
	const tooltipInfo = isBan ? t("suspensions:bannedAccount") : "";

	const handleAddLink = () => {
		if (!link.trim().length) {
			return;
		}
		setIsAdding(true);

		dispatch(addLink({ link, type }))
			.then((action) => {
				if (action.type === addLink.fulfilled.type) {
					toast.success(t("userpanel:links.linkHasBeenAdded"));
					dispatch(getLinks());
				} else if (action.type === addLink.rejected.type) {
					toast.error(action.payload.response.data.error);
				}
			})
			.finally(() => {
				setIsAdding(false);
				setType(null);
				setLink("");
			});
	};

	const typesOfLinks = [
		{ key: 1, value: 1, content: "Instagram" },
		{ key: 2, value: 2, content: "Pornhub" },
		{ key: 3, value: 3, content: "Onlyfans" },
	];

	// #####################################################

	return (
		<Block flex column withRowGap>
			<UserpanelSection headingText={t("userpanel:links.header")}>
				<UserpanelRow>
					<Block>
						<SelectorSelectSingle
							label={t("userpanel:links.linkType")}
							emptyText={t("common:choose")}
							items={typesOfLinks}
							selected={type}
							onAccept={(value) => {
								setType(value);
							}}
							withMobileVersion
							activatorStyleOptions={{
								noPad: true,
								noTopMargin: true,
								flex1: true,
							}}
							disabled={isBan}
						/>
					</Block>
				</UserpanelRow>
			</UserpanelSection>
			<UserpanelSection>
				<UserpanelRow>
					<InputSelector
						value={link}
						label={t("userpanel:links:textareaInfo")}
						placeholder={t("userpanel:links:textareaInfo")}
						onAccept={(value) => setLink(value)}
						autoComplete="off"
						noPad
						disabled={isBan}
					/>
				</UserpanelRow>
			</UserpanelSection>

			{/* Przycisk Zapisz */}
			<Block flex justifyEnd>
				<Tooltip
					text={tooltipInfo}
					wrapperStyle={{
						position: "relative",
						left: 0,
						right: 0,
						top: 0,
						bottom: 0,
					}}
				>
					<ButtonPrimary
						label={t("userpanel:photos.add")}
						onClick={handleAddLink}
						disabled={isBan || isAdding}
					/>
				</Tooltip>
			</Block>
		</Block>
	);
};

// #####################################################

export default AddingForm;

// #####################################################
